import { UIDAPresentationTypeEnum, CategoryUidaAsset } from '../compat/tvpil';
import { tvpil } from '../compat/tvpil';

import { Channel } from './types';

export function getLimit(category: CategoryUidaAsset) {
  if (category.subtype === UIDAPresentationTypeEnum.hero) {
    return category?.railProperty.railItemsLimit ?? Number.MAX_SAFE_INTEGER;
  }
}

export function shouldPresentChannel(channel: Channel): boolean {
  return Boolean(channel.channelNumber) && (channel.isEntitled || channel.representPackage);
}

export function shouldIncludeAdult(category: CategoryUidaAsset) {
  if (category.subtype === UIDAPresentationTypeEnum.favorites) {
    return false;
  }

  return tvpil.transactionStore.isAdultEntitled;
}
